<template>
  <DetailCard :loading="loading" :error="errorMessage">
    <template #heading>
      <span class="pi pi-map-marker"></span>
      {{ $t(`messages.detail.map.macro`) }}
    </template>
    <template #controls>
      <label v-if="!loading" for="detail-map-macro-switch" class="mb-0">
        {{ $t(`messages.detail.map.onoff`) }}
      </label>
      <ToggleSwitch
        v-if="!loading"
        id="detail-map-macro-switch"
        v-model="status"
        class="ml-2"
      ></ToggleSwitch>
      <MapHelpTooltip v-if="!loading" size="sm" variant="secondary" class="ml-2" />
    </template>

    <div id="detail-macro-map" class="detail-map">
      <MapComponent
        :center="center"
        :extent="mapview.extent"
        :zoom="zoom"
        :minZoom="mapview.minZoom"
        :maxZoom="mapview.maxZoom"
        :projection="mapview.projection"
        :baseLayers="mapview.baseLayers"
        :infoLayers="infoLayers"
        :overlay="overlay"
        :zoomToFeatures="true"
        :zoomControl="true"
        :twoFingerPanZoom="true"
        @update="exportMap"
        ref="mapRef"
      />
      <div class="map-cover" v-if="!status"></div>
    </div>
  </DetailCard>
</template>

<script setup>
import DetailCard from '@/components/detail/DetailCard.vue'
import MapComponent from '@/components/map/MapComponent.vue'
import MapHelpTooltip from '@/components/map/MapHelpTooltip.vue'
import { useMicroMacroDetailMap } from '@/composables/useMicroMacroDetailMap'
import {
  DETAIL_MACRO_MAP_FEATURE_LAYER,
  DETAIL_MACRO_MAP_INFO_LAYERS,
} from '@/constants'
import { createGeoJsonFeature } from '@/services/map/FeatureService'

const createMacroMapFeatures = (id, geometry, featureLayerFn, overlayRef) => {
  const layer = featureLayerFn()
  geometry.forEach(item => {
    layer.features.push(createGeoJsonFeature(item, { id }))
  })

  overlayRef.value = layer
}

const {
  mapRef,
  loading,
  status,
  center,
  zoom,
  overlay,
  infoLayers,
  mapview,
  exportMap,
  errorMessage,
} = useMicroMacroDetailMap({
  mapType: 'macro',
  featureLayerId: DETAIL_MACRO_MAP_FEATURE_LAYER,
  infoLayersIds: DETAIL_MACRO_MAP_INFO_LAYERS,
  createMapFeaturesFunction: createMacroMapFeatures,
})

defineExpose({ exportMap })
</script>

<style scoped lang="css">
  .detail-map {
    position: relative;
    height: 600px;
    width: 100%;
    margin: 0;

    .map-cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      backdrop-filter: blur(5px) grayscale(80%);
      z-index: 3;
    }
  }
</style>
